/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateRoleCourseDataParser = 
/* #__PURE__ */ parsers.object([['name', codecString]]);
export class CreateRoleCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateRoleCourseDataParser.decode(input).map(res => new CreateRoleCourseData(res));
    }
    static unsafeDecode(input) {
        return CreateRoleCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateRoleCourseDataParser.encode(data);
    }
    static schema() {
        return CreateRoleCourseDataParser.schema();
    }
}
